import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "component", "href", "size", "dangerouslyForceHoverStyling", "dangerouslyForceFocusStyling", "dangerouslyForceActiveStyling", "disabled", "gotham"];
import "core-js/modules/es6.string.link.js";
import React from 'react';
import classNames from 'classnames';
import { Type } from '../Type/Type';
import styles from './SimpleLink.module.less';

var inferType = function inferType(Component) {
  // Should use type=button when using a `<button>` component, but not needed
  // when using `<a>`. This can be overridden by passing a `type` prop.
  if (Component === 'button') {
    return {
      type: 'button'
    };
  }

  return {};
};
/**
 * `<Link>` will inherit font family and size if none are specified. For
 * example, no `size` prop is needed here:
 *
 *  <Text size="small">
 *    <Link href="#">Click</Link>
 *  </Text>
 *
 * Size can be customized with the size prop. If possible, prefer the semantic
 * `small` and `legal` sizes:
 *
 *   <Link size="small" />
 *   <Link size="legal" />
 *
 * However, if needed, numeric sizes in the range [0, 5] can be used instead.
 * See `<Type>` component for more implementation details on these
 * sizes.
 */


var validSizes = [0, 1, 2, 3, 4, 5];
var linkLevelSizeMap = {
  small: 1,
  legal: '0'
};
export var SimpleLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var children = props.children,
      className = props.className,
      component = props.component,
      href = props.href,
      size = props.size,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling,
      disabled = props.disabled,
      gotham = props.gotham,
      otherProps = _objectWithoutProperties(props, _excluded); // Component overrides


  var Component = component || (href ? 'a' : 'button');
  return (
    /*#__PURE__*/
    // @ts-expect-error -- Unfortunately, this whole thing is a type error,
    // as `<a>` doesn't have a `disabled` prop and `<button>` doesn't have
    // an `href` prop.
    // TODO: consider splitting this component into `<TextLink>` and `<ButtonLink>`
    // in a future major version of Currency.
    React.createElement(Type, _extends({}, inferType(Component), {
      className: classNames(className, styles.link, (_classNames = {}, _defineProperty(_classNames, styles['button-unstyling'], Component === 'button'), _defineProperty(_classNames, styles['type-inherit-font-size'], size == null), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles['force-active'], dangerouslyForceActiveStyling), _defineProperty(_classNames, styles['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_classNames, styles['force-hover'], dangerouslyForceHoverStyling), _defineProperty(_classNames, styles['font-family-inherit'], !gotham), _classNames)),
      component: Component // Don't render this prop to the DOM unless we're actually disabled
      ,
      disabled: disabled || undefined,
      href: href,
      ref: ref // Get the numeric size if a semantic
      // size prop is used (eg. "small")
      ,
      size: linkLevelSizeMap[size] || size,
      "data-currency": "Link",
      fontFamily: gotham ? 'gotham' : undefined
    }, otherProps), children)
  );
});
SimpleLink.displayName = 'SimpleLink';